var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-container"},[_c('div',{staticClass:"md-icon"},[_vm._v("check_circle")]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('login_successfull')))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('login_successfull_info')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }